import { apiCall } from './ApiCall';

export const getAllTypeExpos = ({ cursor, limit } = {}) => apiCall("getalltype_expos")